module.exports = __webpack_public_path__ + "static/scale-model-of-grand-staircase-in-san-jose-california-d1cd9c55d2fcd36c51bc0ea29b0ffcfd.png";